<template>
  <div class="text-white overflow-hidden font-inter">
    <AnimatedBackground />
    
    <div class="mx-auto px-4 py-12">
      <header class="mb-10">
        <PageTitle>
          Seus Prêmios e Conquistas
        </PageTitle>
        <PageDescription class="text-gray-400">
          Acompanhe seu progresso e visualize seus prêmios.
        </PageDescription>
      </header>
      
      <AwardsContainer :awards="awards" />
    </div>
  </div>
</template>

<script setup>
import PageTitle from '@/components/ui/page/PageTitle.vue';
import AwardsContainer from './components/AwardsContainer.vue'
import PageDescription from '@/components/ui/page/PageDescription.vue';
// Componente sem estado, apenas renderização da UI

const awards = [
  {
    id: '1',
    title: 'Primeiro Marco',
    subtitle: 'Placa de 50K',
    imageUrl: '/img/awards/BOT - 50k.png',
    value: '50K',
    targetAmount: 50000,
    currentAmount: 15000,
    nextMilestone: '100 Mil'
  },
  {
    id: '2',
    title: 'Mestre',
    subtitle: 'Placa de 100K',
    imageUrl: '/img/awards/BOT - 100k.png',
    value: '100K',
    targetAmount: 100000,
    currentAmount: 15000,
    nextMilestone: '100 Mil'
  },
  {
    id: '3',
    title: 'Elite',
    subtitle: 'Placa de 500K',
    imageUrl: '/img/awards/BOT - 500k.png',
    value: '1KK',
    targetAmount: 500000,
    currentAmount: 25000,
    nextMilestone: '500 Mil'
  },
  {
    id: '4',
    title: 'Lenda',
    subtitle: 'Placa de 1M',
    imageUrl: '/img/awards/BOT - 1M.png',
    value: '5KK',
    targetAmount: 1000000,
    currentAmount: 20000,
    nextMilestone: '1 Milhão'
  }
];
</script>

<style>

</style>